<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WRyJyv/tc-custom/9781625852113.jpg?1737919537224" alt="This image is the cover for the book Cleveland Cavaliers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cleveland Cavaliers
      </h1>
      <p class="bookDescription body article font2">
        <b>Photos, interviews, behind-the-scenes stories, and in-depth analysis—the ultimate team history for Cavs fans!</b><br/>  <br/> Take a courtside seat with sportswriter Vince McKee as he dishes out the history of the Cleveland Cavaliers from the founding of the franchise in 1970 to the triumphant return of LeBron James in 2014. Highlights include draft picks turned all-stars, such as James and Brad Daugherty; coaching changes; heated rivalries; player departures; and dubious distinctions like “the Shot” and “the Stepien Rule.”<br/>  <br/> You’ll also get insight and analysis of every epic run from legendary sportscaster Joe Tait; players Austin Carr, Craig Ehlo, and Larry Nance; and others as they reveal the untold true stories behind the major events in Cavs history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vince McKee, Austin Carr, Fred McLeod, Mary Schmitt Boyer, Craig Ehlo, Larry Nance
      </h2>
      
      <p class="authorDescription body article">VinceMcKee is a growing force in the sports literary world. His first seven booksall helped to build his credibility as a top-notch chronicler of the impact ofOhio sports. Vince is also the MMA correspondent for neosportsinsiders.com. Hehas also spent time as a High School Beat Reporter for the Cleveland PlainDealer & The Medina Gazette.  His work has been featured in SLAMMagazine, ESPN Sports Nation and Drennan Live.  He has been called the goto source with anything involving sports history. He has personally interviewedsome of the biggest names in Cleveland Sports history for his books, includinga one on one with Bill Belichick.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4648440c